import { observable, action } from "mobx";
import { isDataExist } from "Utils/dataTools";
import * as services from "../services/basic";

class Warehouse {
  @observable isLoading = false;
  @observable tableData = [];
  @observable childrenWarehouse = [];
  @observable processList = [];
  @observable zeroHouse = [];
  @observable PageInfo = { pageIndex: 1, pageSize: 100 };
  @observable formData = {};
  @observable searchData = "";
  @observable modalVisible = false;

  @observable expandedRowKeys = [];

  @observable warehouseTypeData = []; // 获取的仓库类型数据
  @observable currentWarehouseType = "";

  @observable operateType = "";

  //获取表格数据
  @action.bound async getData(type, params) {
    this.isLoading = true;
    //1仓库类型列表，2仓库列表
    const url =
      type === 1
        ? services.requestUrl.warehouseTypeList
        : services.requestUrl.warehouseList;
    if (type === 2) {
      params.parentId = 0;
    }
    try {
      let res = await services.getRequest(url, { ...params, ...this.PageInfo });
      this.isLoading = false;
      if (isDataExist(res)) {
        this.tableData = res.data.data.items;
        this.PageInfo = res.data.data.page;
      }
    } catch (error) {
      console.log(error);
    }
  }
  //获取表格数据
  @action.bound async getZeroHouse(params) {
    this.isLoading = true;
    try {
      let res = await services.getRequest(
        services.requestUrl.zeroWarehouse,
        params
      );
      this.isLoading = false;
      if (isDataExist(res)) {
        this.zeroHouse = res.data.data;
      }
    } catch (error) {
      console.log(error);
    }
  }
  //获取工序列表
  @action.bound async getProList(params) {
    this.isLoading = true;
    try {
      let res = await services.getRequest(
        services.requestUrl.allProcess,
        params
      );
      this.isLoading = false;
      if (isDataExist(res)) {
        this.processList = res.data.data;
      }
    } catch (error) {
      console.log(error);
    }
  }
  @action async getWarehouseType(params) {
    try {
      let res = await services.getRequest(
        services.requestUrl.getAllWarehouseType,
        params
      );
      if (isDataExist(res)) {
        this.warehouseTypeData = res.data.data;
      }
    } catch (error) {
      console.log(error);
    }
  }
  //获取嵌套子表数据
  @action.bound async getChildrenWarehouse(params) {
    this.isLoading = true;
    const url = services.requestUrl.getAllwarehouse;
    try {
      let res = await services.getRequest(url, params);
      this.isLoading = false;
      if (isDataExist(res)) {
        this.childrenWarehouse = res.data.data;
      }
    } catch (error) {
      console.log(error);
    }
  }
  //保存更新信息
  @action.bound async saveData(type, params) {
    this.isLoading = true;
    //1仓库类型列表，2仓库列表
    const url =
      type === 1
        ? services.requestUrl.savewarehouseType
        : services.requestUrl.savewarehouse;
    try {
      let res = await services.putRequest(url, params);
      this.isLoading = false;
      if (isDataExist(res)) {
        return res;
      }
    } catch (error) {
      console.log(error);
    }
  }
  // 删除仓库
  @action.bound async deleteWarehouse(type, params) {
    this.isLoading = true;
    //1仓库类型列表，2仓库列表
    const url =
      type === 1
        ? services.requestUrl.deleteWarehouseType
        : services.requestUrl.deleteWarehouse;
    try {
      let res = await services.putRequest(url, params);
      this.isLoading = false;
      if (isDataExist(res)) {
        return res;
      }
    } catch (error) {
      console.log(error);
    }
  }
  //打开/关闭模态框
  @action modalChange = (type, record) => {
    this.operateType = type;
    if (type) {
      this.formData = record;
    } else {
      this.formData = {};
    }
    this.modalVisible = !this.modalVisible;
  };
  // 清除数据
  @action clearData() {
    this.tableData = [];
    this.PageInfo = { pageIndex: 1, pageSize: 100 };
    this.searchData = "";
    this.modalVisible = false;
    this.formData = {};
  }
}

let WarehouseStore = new Warehouse();
export default WarehouseStore;
